import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DestinationTypeahead from '@homeaway/react-destination-typeahead';
import './style.less';

export default class Typeahead extends Component {
    static propTypes = {
        query: PropTypes.string,
        locale: PropTypes.string,
        labels: PropTypes.shape({}),
        typeaheadProps: PropTypes.shape({}),
        inputIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
        isTypeaheadInputFocus: PropTypes.bool,
        onBlur: PropTypes.func,
        consolidateInputs: PropTypes.bool
    };

    static defaultProps = {
        query: ''
    };

    render() {
        const {
            query,
            locale,
            typeaheadProps,
            inputIcon: icon,
            isTypeaheadInputFocus,
            onBlur,
            onSearchSelected,
            consolidateInputs}
            = this.props;

        const destinationTypeahead = (
            <DestinationTypeahead
                search={query}
                defaultSearch={query}
                messages={this.props.labels}
                {...{onBlur, locale, onSearchSelected, isTypeaheadInputFocus, icon}}
                {...typeaheadProps}
            />
        );

        if (consolidateInputs) {
            return (
                <div className={'consolidate-inputs-destination'}>
                    {destinationTypeahead}
                </div>
            );
        }

        return (
            destinationTypeahead
        );
    }
}
